module.exports = __webpack_public_path__ + "static/media/coliseu_box_8.0014d471.jpg";